"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generate2c2pLink = void 0;
const payments_1 = require("../payments");
const generate2c2pLink = async ({ supabase, payment_provider_id, invoice_id, payment_request_id, currency, amount, env, client, jose, }) => {
    // get the config and fee for the payment gateway
    const gateway = await (0, payments_1.getPaymentGatewayById)(supabase, payment_provider_id);
    const api_config = gateway.api_config.find((config) => {
        return config.env.toLowerCase() === env.toLowerCase();
    });
    if (!gateway) {
        throw new Error("No gateway found");
    }
    const data = {
        merchantID: api_config.merchant_id,
        invoiceNo: invoice_id,
        description: `Payment for ${invoice_id}`,
        amount: amount,
        userDefined1: `${payment_request_id}`,
        currencyCode: currency,
        tokenize: true,
        paymentChannel: ["CC"],
        uiParams: {
            userInfo: {
                name: client?.first_name + " " + client?.last_name,
                email: client?.email,
                mobileNo: client?.display_currency,
            },
        },
    };
    const alg = "HS256";
    const secret = new TextEncoder().encode(api_config.SHA_key);
    const signed_jwt = await new jose.SignJWT(data)
        .setProtectedHeader({ alg })
        .sign(secret);
    // sent POST request
    const response = await fetch(env === "LIVE"
        ? "https://pgw.2c2p.com/payment/4.3/paymentToken"
        : "https://sandbox-pgw.2c2p.com/payment/4.1/paymentToken", {
        body: JSON.stringify({ payload: signed_jwt }),
        headers: {
            "Content-Type": "application/json",
        },
        method: "POST",
    });
    // if response is not ok, throw error
    if (!response.ok) {
        return new Response(JSON.stringify({ error: response.statusText }), {
            headers: { "Content-Type": "application/json" },
            status: 400,
        });
    }
    const pay_response = await response.json();
    const payload = jose.decodeJwt(pay_response.payload);
    const { webPaymentUrl } = payload;
    return webPaymentUrl;
};
exports.generate2c2pLink = generate2c2pLink;
